import { render } from "./searchWindowDesktop.vue?vue&type=template&id=623c382a&scoped=true"
import script from "./searchWindowDesktop.vue?vue&type=script&lang=js"
export * from "./searchWindowDesktop.vue?vue&type=script&lang=js"

import "./searchWindowDesktop.vue?vue&type=style&index=0&id=623c382a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623c382a"]])

export default __exports__